import type { cs } from './cs';

/**
 * Slovak, for the Slovak providers. Typed against `cs` so a key added there
 * and forgotten here is a compile error rather than a raw key on screen.
 */
export const sk: typeof cs = {
  appName: 'NextinQ',
  enums: {
    sharingInfo: {
      fullName: 'Celé meno',
      email: 'Email',
      phoneNumber: 'Telefón'
    },
    wsConnectionStatus: {
      connecting: 'prebieha pripájanie ...',
      error: 'Chyba spojenia'
    }
  },
  auth: {
    emailLead: 'Zadajte svoj email, pošleme Vám prihlasovací kód',
    emailPlaceholder: 'vas@email.sk',
    continue: 'Pokračovať',
    sending: 'Odosielanie ...',
    codeLead: 'Ak email %{email} poznáme, poslali sme naň šesťmiestny kód',
    signIn: 'Prihlásiť sa',
    verifying: 'Overovanie ...',
    signingIn: 'Prihlasovanie ...',
    signInAgain: 'Prihlásiť sa znova',
    changeEmail: 'Zmeniť email',
    errors: {
      invalidEmail: 'Nesprávny formát emailu',
      tooManyRequests: 'Príliš veľa pokusov, skúste to prosím neskôr',
      requestFailed: 'Kód sa nepodarilo odoslať, skúste to prosím znova',
      emailDeliveryFailed: 'Email sa nepodarilo doručiť, skúste to prosím znova',
      invalidCode: 'Nesprávny kód',
      expiredCode: 'Platnosť kódu vypršala, nechajte si poslať nový',
      tooManyAttempts: 'Príliš veľa pokusov, nechajte si prosím poslať nový kód',
      invalidToken: 'Neočakávaná chyba, skúste prosím akciu zopakovať',
      invalidOrExpiredToken: 'Platnosť prihlásenia vypršala, prihláste sa prosím znova',
      unknownError: 'Neočakávaná chyba, skúste prosím akciu zopakovať'
    }
  },
  buttons: {
    ok: 'Ok',
    signOut: 'Odhlásiť sa',
    enterPIN: 'Mám lístok',
    checkIn: 'Chcem lístok',
    addProvider: 'Pridať posk.',
    next: 'Ďalej',
    remoteCheckin: 'Zaradiť sa',
    updateProfile: 'Upraviť profil',
    leaveQueue: 'Opustiť rad',
    saveProfile: 'Uložiť profil'
  },
  successes: {
    userProfileUpdated: 'Váš profil bol uložený',
    providerCodeEntered: 'Poskytovateľ bol pridaný do Vašich služieb'
  },
  errors: {
    invalidEmail: 'Nesprávny formát emailu',
    invalidPhone: 'Nesprávny formát tel. čísla',
    fullNameMinLength: 'Meno je príliš krátke',
    fullNameMaxLength: 'Meno je príliš dlhé (max. 30 znakov)',
    invalidCode: 'Nesprávny kód poskytovateľa služby',
    invalidPIN: 'Nesprávny PIN lístka',
    serverError: 'Neočakávaná chyba, skúste prosím akciu zopakovať',
    unknownError: 'Neočakávaná chyba, skúste prosím akciu zopakovať',
    invalidQueueId: 'Neočakávaná chyba, skúste prosím akciu zopakovať',
    queueClosed: 'Rad je zatvorený',
    remoteCheckinDisabled: 'Poskytovateľ nepovolil pre tento rad vzdialené prihlásenie',
    tooManyCheckins:
      'Prekročili ste povolený počet vzdialených prihlásení za deň do tohto radu',
    invalidTicketId: 'Tento lístok už v rade nie je',
    notYourTicket: 'Tento lístok Vám nepatrí',
    alreadyCheckedIn: 'V tomto rade už lístok máte',
    ticketAlreadyClaimed: 'Tento lístok je už priradený inému účtu',
    tooManyAttempts: 'Príliš veľa pokusov, skúste to prosím neskôr',
    internalError: 'Neočakávaná chyba, skúste prosím akciu zopakovať',
    unknownCommand: 'Neočakávaná chyba, skúste prosím akciu zopakovať'
  },
  screen: {
    registerQueue: {
      title: 'Kód poskytovateľa'
    },
    registerTicket: {
      title: 'Zadajte PIN lístka'
    },
    userProfile: {
      title: 'Môj profil'
    },
    sharingInfo: {
      title: 'Zaradiť sa'
    },
    remoteCheckin: {
      title: 'Zaradiť sa'
    },
    leaveQueue: {
      title: 'Naozaj opustiť rad?',
      message1: 'Po opustení radu stráca lístok platnosť',
      message2:
        'Opustením radu nám pomáhate urýchliť vybavenie ostatných zákazníkov - ďakujeme.'
    },
    error: {
      title: 'Chyba pripojenia',
      info: 'Bohužiaľ sa nemôžeme spojiť s naším serverom',
      actionInfo: 'Skontrolujte pripojenie k internetu a skúste to znova',
      tryAgain: 'Skúsiť znova'
    },
    sharingInfoScreen: {
      infoText1: 'Vyberte prosím údaje, ktoré chcete zobraziť poskytovateľovi',
      infoText2: 'Môžete tým urýchliť Vaše vybavenie.',
      completeUserProfileInfo:
        'Aby ste mohli zdieľať všetky údaje, dokončite prosím nastavenie Vášho profilu',
      gotoProfile: 'Upraviť môj profil'
    },
    remoteCheckinScreen: {
      summary: 'Zaradiť sa do radu na túto službu',
      sharingInfoTitle: 'súhlasíte s poskytnutím týchto Vašich údajov:',
      noSharedItems: 'Neposkytovať tejto službe žiadne údaje - anonymné zaradenie'
    }
  },
  titles: {
    myQueues: 'Moje služby',
    checkedQueues: 'Moje zaradenia'
  },
  statuses: {
    queueStatus: {
      open: 'Otvorené',
      closed: 'Zatvorené',
      disconnected: 'Odpojené'
    },
    queueInfo: {
      servedNow: 'Ste na rade, vstúpte prosím',
      overdue: 'Už ste boli volaný(á), vstúpte prosím',
      peopleInQueue: {
        smartCount:
          'Čaká tu len 1 človek |||| Čakajú tu %{smart_count} ľudia |||| Čaká tu %{smart_count} ľudí',
        zero: 'Čakáreň je prázdna'
      },
      peopleInFrontOfMe: {
        zero: 'Ste ďalší na rade, počkajte prosím na vyzvanie',
        smartCount:
          'Len %{smart_count} človek čaká pred Vami |||| Len %{smart_count} ľudia čakajú pred Vami |||| %{smart_count} ľudí čaká pred Vami'
      },
      onePersonInQueue: 'Čaká tu len 1 človek',
      queueEmpty: 'Čakáreň je prázdna'
    }
  },
  components: {
    userProfile: {
      email: 'Email',
      fullName: 'Celé meno',
      phoneNumber: 'Telefón'
    },
    dialCodeSelector: {
      selectCodeTitle: 'Vyberte predvoľbu'
    },
    userProfileButton: {
      myProfile: 'Môj profil'
    }
  }
};
